<template>
    <div id="topMostElement" class="providerSection">
        <v-btn
            v-if="screen_width <= 630"
            icon
            class="black--text"
            @click="isAcuApprovalValid = false"
        >
            <v-icon
                dark
                left
            >
                {{ mdiArrowLeft }}
            </v-icon>
        </v-btn>
        <h1>
            <v-icon
                v-if="screen_width > 520"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiAccountHeart }}
            </v-icon>Annual Check Up
            <v-btn
                v-if="isAcuApprovalValid && screen_width > 480"
                style="position: absolute; right: 0; background-color: #009688; color: white;"
                class="ma-2"
                dark
                @click="isAcuApprovalValid = false"
            >
                <v-icon
                    dark
                    left
                >
                    {{ mdiChevronLeft }}
                </v-icon>BACK
            </v-btn>
        </h1>
        <div class="docInfoBody">
            <VerifyAcuApprovalTemplate
                v-if="!isAcuApprovalValid"
                @acuApprovalValid="isAcuApprovalValid = true"
            />
            <AcuForm v-show="isAcuApprovalValid" />
        </div>
    </div>
</template>

<script>
import VerifyAcuApprovalTemplate from './VerifyAcuApprovalTemplate.vue'
import AcuForm from './AcuForm/index.vue'
import { mapActions } from 'vuex'
import { mdiAccountHeart, mdiArrowLeft, mdiChevronLeft } from '@mdi/js'
export default {
    components: {
        VerifyAcuApprovalTemplate, AcuForm
    },
    data: ()=>({
        mdiAccountHeart, mdiArrowLeft, mdiChevronLeft,
        patientData: null,
        isAcuApprovalValid: false,
        screen_width: document.documentElement.clientWidth + 9
    }),
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken']),
        handleUpdateItemTbl(patientData) {
            this.patientData = structuredClone(patientData)
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    position: relative;
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 15px
}
.providerSection {
    position: relative;
    padding: 10px 7.5% 0 7.5%;
}
@media (max-width: 380px) {
  .providerSection {
    position: relative;
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (max-width: 599px) {
  .providerSection {
    position: relative;
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .providerSection {
    position: relative;
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 1264px) {
  .providerSection {
    position: relative;
    padding: 10px 7.5% 0 7.5%;
  }
}
</style>
